import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0.001, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0, as: Tag = "h1", testid }) => (
  <Tag className={className} data-testid={testid}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.14 }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono-x text-xs uppercase tracking-[0.28em] text-[#C9A24B] ${className}`}>{children}</p>
);

export const PageHead = ({ eyebrow, title, line, testid }) => (
  <header className="max-w-6xl mx-auto px-6 md:px-10 pt-36 pb-14" data-testid={testid}>
    <Eyebrow>{eyebrow}</Eyebrow>
    <MaskLines lines={[title]} className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-display tracking-tight text-[#F6EFE0]" delay={0.15} />
    {line && (
      <Reveal delay={0.4}>
        <p className="mt-6 max-w-2xl font-accent italic text-xl md:text-2xl text-[#E4C87F]">{line}</p>
      </Reveal>
    )}
    <motion.div className="mt-10 h-px bg-gradient-to-r from-[#C9A24B] via-[#C9A24B]/40 to-transparent origin-left" initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 1.4, ease: EASE, delay: 0.5 }} />
  </header>
);
